module.exports = __webpack_public_path__ + "static/img/full.4877c445.svg";